import React, {Component} from 'react';

class SectionMessageController extends Component{
  constructor(props){
    super(props);
  }
  render(){
    const style = {
      backgroundImage: 'url('+this.props.content.image+')',
      backgroundSize: 'cover'
    }
    return(
      <div className="message" style={style}>
        <h3>{this.props.content.text}</h3>
      </div>
    )
  }
}

export default SectionMessageController;



// WEBPACK FOOTER //
// ./src/components/homepage/views/sectionMessage.js